import APP from 'app'

const FIT_100_100 = '100x100-fit'
const FIT_200_200 = '200x200-fit'
const FIT_220_400 = '220x400-fit'
const FIT_45_45 = '45x45-fit'
const FIT_500_900 = '500x900-fit'
const POST_320_400 = '320x400-post'
const POST_600_750 = '600x750-post'
const POST_800_1000 = '800x1000-post'
const RESIZE_1200_750 = '1200x750-resize'
const RESIZE_160_80 = '160x80-resize'
const RESIZE_220_400 = '220x400-resize'
const RESIZE_320_200 = '320x200-resize'
const RESIZE_500_900 = '500x900-resize'
const RESIZE_600_315 = '600x315-resize'
const RESIZE_1200_630 = '1200x630-resize'
const RESIZE_600_375 = '600x375-resize'
const RESIZE_600_450 = '600x450-resize'
const RESIZE_800_500 = '800x500-resize'

export const IMAGE_SIZES = {
  FIT_45_45,
  FIT_100_100,
  FIT_200_200,
  FIT_220_400,
  FIT_500_900,
  POST_320_400,
  POST_600_750,
  POST_800_1000,
  RESIZE_160_80,
  RESIZE_220_400,
  RESIZE_320_200,
  RESIZE_500_900,
  RESIZE_600_315,
  RESIZE_600_375,
  RESIZE_600_450,
  RESIZE_800_500,
  RESIZE_1200_630,
  RESIZE_1200_750,
}

const CROP = 'crop'
const FIT = 'fit'
const POST = 'post'
const RESIZE = 'resize'

export const IMAGE_EFFECTS = {
  CROP,
  FIT,
  POST,
  RESIZE,
}

export const getImageURL = (filename, imageSize = '') =>
  [
    APP.static_url,
    'images',
    filename.substr(0, 4),
    filename.substr(4, 4),
    filename.replace(/\.(.+)$/, ''),
    imageSize ? `${imageSize}-${filename}` : `sbo_${filename}`,
  ].join('/')
